module.exports = "/assets/success-muffin-rw@2x.png?rIkPCjJ";